<template>
	<Modal
		frameless
		panelClass="flex w-[500px] max-w-full flex-col items-start gap-6 rounded-[12px] border border-[#EFEFEF] bg-white p-8 shadow-[0_8px_16px_-4px_rgba(0,0,0,0.10),0_4px_6px_-2px_rgba(0,0,0,0.05)]"
		@close="$emit('close')"
	>
		<div class="flex w-full flex-col items-center gap-5">
			<div
				class="flex h-[56px] w-[56px] items-center justify-center rounded-[30px] bg-[#E6F4EC]"
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="28"
					height="28"
					viewBox="0 0 28 28"
					fill="none"
					class="h-[28px] w-[28px] shrink-0 aspect-square"
					aria-hidden="true"
				>
					<path
						d="M25.4344 11.6664C25.9672 14.2813 25.5875 16.9997 24.3585 19.3685C23.1296 21.7373 21.1257 23.6131 18.6811 24.6833C16.2365 25.7534 13.4989 25.9532 10.9249 25.2492C8.35084 24.5452 6.09593 22.98 4.53619 20.8147C2.97646 18.6494 2.20618 16.0149 2.35381 13.3504C2.50145 10.6859 3.55806 8.15251 5.34746 6.17278C7.13686 4.19304 9.55088 2.88658 12.1869 2.47127C14.823 2.05597 17.5218 2.55691 19.8332 3.89058"
						stroke="#2B503C"
						stroke-width="2.33333"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
					<path
						d="M10.5 12.8332L14 16.3332L25.6667 4.6665"
						stroke="#2B503C"
						stroke-width="2.33333"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
				</svg>
			</div>
			<div class="flex w-full flex-col gap-2">
				<div class="flex w-full items-start justify-center">
					<h3
						class="m-0 w-full text-center text-[20px] font-medium leading-[28px] tracking-[0.3px] text-[#171717]"
					>
						{{ $t('application.submitted.heading') }}
					</h3>
				</div>
				<p
					class="m-0 w-full whitespace-pre-line text-center text-[16px] font-normal leading-[22px] text-[#2A2C2C]"
				>{{ message }}</p>
			</div>
		</div>

		<div class="flex w-full flex-col gap-3">
			<Button
				type="primary"
				class="w-full"
				data-test="view-applications-button"
				@click="$emit('view-applications')"
			>
				{{ $t('application.submitted.view-my-applications') }}
			</Button>
			<Button
				type="secondary"
				class="w-full"
				data-test="go-dashboard-button"
				@click="$emit('go-dashboard')"
			>
				{{ $t('general.go-to-dashboard') }}
			</Button>
		</div>
	</Modal>
</template>

<script>
import Modal from '~/components/ui/layout/Modal'
import Button from '~/components/ui/common/Button'

export default {
	props: {
		companyName: {
			type: String,
			default: ''
		},
		jobOfferName: {
			type: String,
			default: ''
		}
	},
	components: {
		Modal,
		Button
	},
	computed: {
		message() {
			const job = this.jobOfferName?.trim()
			const company = this.companyName?.trim()

			const text =
				job && company
					? this.$t('application.submitted.applied-for', { job, company })
					: this.$t('application.submitted.message')

			return String(text).trim()
		}
	}
}
</script>
